import { Injectable, TemplateRef } from '@angular/core';

enum SignalRStates{
  reconnecting,
  reconnected,
  closed
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: any[] = [];

  // Push new Toasts to array with content and options
  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    // Make sure toasts array doesnt grow bigger than 6
    if (this.toasts.length >= 6) {
      this.toasts.shift();
    }
    this.toasts.push({ textOrTpl, ...options });
  }

  // Callback method to remove Toast DOM element from view
  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  signalRClose(text: string){
    this.toasts = this.toasts.filter(x => x.signalRStatus !== SignalRStates.reconnecting);
    this.show(text, {
      classname: 'toast-error text-light toast animated fadeIn pre-wrap',
      autohide: false,
      headertext: 'Connection Lost',
      signalRStatus: SignalRStates.closed
    });
  }

  signalRReconnecting(text: string){
    this.show(text, {
      classname: 'toast-warn text-dark toast animated fadeIn pre-wrap',
      autohide: false,
      headertext: 'Disconnected',
      signalRStatus: SignalRStates.reconnecting
    });
  }

  signalRReconnected(text: string, delay: number = null){
    this.toasts = this.toasts.filter(x => x.signalRStatus !== SignalRStates.reconnecting);
    const toastDelay = delay === null ? 6000 : delay;
    this.show(text, {
      classname: 'toast-success text-light toast animated fadeIn pre-wrap',
      delay: toastDelay,
      autohide: true,
      headertext: 'Re-Connected',
      signalRStatus: SignalRStates.reconnected
    });
  }

  showSuccess(bodyText: string, delay: number = null) {
    const toastDelay = delay === null ? 8000 : delay;
    this.show(bodyText, {
      classname: 'toast-success text-light toast animated fadeIn pre-wrap',
      delay: toastDelay,
      autohide: true,
      headertext: 'Success',
    });
  }

  showError(bodyText: string, delay: number = null) {
    const toastDelay = delay === null ? 10000 : delay;
    this.show(bodyText, {
      classname: 'toast-error text-light toast animated fadeIn pre-wrap',
      delay: toastDelay,
      autohide: true,
      headertext: 'Error',
    });
  }

  missingRequiredFields(){
    this.showError('You are missing one or more required fields. Please check your form and try again.');
  }

  showWarning(bodyText: string, delay: number = null) {
    const toastDelay = delay === null ? 8000 : delay;
    this.show(bodyText, {
      classname: 'toast-warn text-dark toast animated fadeIn pre-wrap',
      delay: toastDelay,
      autohide: true,
      headertext: 'Warning',
    });
  }

  featureUnderConstruction(featureName: string){
    this.showWarning(`The feature '${featureName}' is currently under construction.`);
  }
}
